'use strict';

import mediator from '../../js/mediator';
import config from '../../js/config';
import * as featureFlags from '../../utilities/featureFlags';
import utilities from '../../js/utilities';
import NotificationBar from '../NotificationBar/NotificationBar';
import template from './templates/TieredPricingNotificationBar.hbs';
import cartApi from '../../services/CartAPI';

export default class TieredPricingNotificationBar extends NotificationBar {

  initialize() {
    this.template = template;
    this.initializeEvents();
    if (featureFlags.HideArrowPerksBarForLoyaltyUser.isEnabled() && window.Arrow.isAuthorized && (window.location.href.indexOf('/products/search') > 0 || window.location.href.indexOf('/cart') > 0)) {
      this.showNotificationBar();
    }
    else {
      if (this.model.showingTieredPricing) {
        this.showNotificationBar();
      }
    }
  }

  initializeEvents() {
    mediator.on(config.events.header.showTieredPricingNotification, () => {
      this.showNotificationBar();
    });

    mediator.on(config.events.header.hideTieredPricingNotification, () => {
      this.dismiss();
    });
  }

  canDisplayNotificationBar() {
    let display = false;
    if (!utilities.localStorageLoad(config.cookies.hideTieredPricingNotification)) {
      if (featureFlags.HideArrowPerksBarForLoyaltyUser.isEnabled()) {
        let currentUser;
        if (featureFlags.EnableB2BUsersApiCall.isEnabled()) {
          cartApi.getLoyaltyUser().then((b2bUserData) => {
            if (b2bUserData) {
              currentUser = b2bUserData;
            }
          });
        } else {
          currentUser = utilities.sessionStorageLoad(config.sessionVariables.header.b2busers);
        }
        if (currentUser && currentUser.loyalty && !currentUser.loyalty.optInFlag) {
          display = true;
        }
      }
      else {
        display = true;
      }
    }
    return display;
  }

  showNotificationBar() {
    if (this.canDisplayNotificationBar()) {
      this.show();
    }
  }

  dismiss(e) {
    if (e) {
      e.stopPropagation();
    }
    utilities.localStorageSave(config.cookies.hideTieredPricingNotification, true);
    this.hide();
  }
}

export function createTieredPricingNotificationBar($parent) {
  let $notificationBar = $parent.find('#TieredPricingNotificationBar');
  let $showingTieredPricing = $parent.find('.' + config.classes.tieredPricing).length > 0;
  if ($notificationBar.length) {
    new TieredPricingNotificationBar({el: $notificationBar, model: {showingTieredPricing: $showingTieredPricing}});
  }
}



// WEBPACK FOOTER //
// ./assets/components/TieredPricingNotificationBar/TieredPricingNotificationBar.js